import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()

const createAgenda = (payload) => AxiosClient.post('/agenda', payload);
const getAllAgendaList = (params) => AxiosClient.get('/agenda', {...params});
const updateAgendaItem = (itemId, payload) => AxiosClient.put(`/item/${itemId}`, { ...payload })
const getSingleAgendaDetails = (agendaId) => AxiosClient.get(`/agenda/${agendaId}`)
const createAgendaItemsRoute = (payload) => AxiosClient.post('/item', payload);
const deleteAgendaItemsRoute = (itemId, payload) =>
  AxiosClient.delete(`/item/${itemId}`, { data: payload });
  // const updateAgendaRoute = (agenda, payload) => AxiosClient.put(`/agenda/${agenda}`, { ...payload })
  const deleteAgendaRoute = (agendaId, payload) =>
  AxiosClient.delete(`/agenda/${agendaId}?companyId=${payload.companyId}`);

  const updateAgendaRoute = (agenda, payload) => {
  const dataToSend = payload.formData instanceof FormData ? payload.formData : payload;

  return AxiosClient.put(`/agenda/${agenda}`, dataToSend, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};



export {
    createAgenda,
    getAllAgendaList,
    updateAgendaItem,
    getSingleAgendaDetails,
    createAgendaItemsRoute,
    updateAgendaRoute,
    deleteAgendaItemsRoute,
    deleteAgendaRoute
}